import React from "react";
import {
  Flex, Text, Icon, Box, Button, Divider,
  useColorMode, useColorModeValue, Switch,
} from "@chakra-ui/react";
import {
  MdDarkMode, MdLightMode, MdLogout,
} from "react-icons/md";
import Card from "components/card/Card.js";
import { signOut } from "firebase/auth";
import { auth } from "../../../../../../firebase";
import { useNavigate } from "react-router-dom";

export default function AppPrefs() {
  const { colorMode, toggleColorMode } = useColorMode();
  const isDark = colorMode === "dark";
  const navigate = useNavigate();

  const textColor    = useColorModeValue("navy.700", "white");
  const subColor     = useColorModeValue("gray.500", "gray.400");
  const dividerColor = useColorModeValue("gray.100", "whiteAlpha.200");
  const rowHoverBg   = useColorModeValue("gray.50", "whiteAlpha.50");

  const handleLogout = async () => {
    await signOut(auth);
    navigate("/auth/sign-in/default", { replace: true });
  };

  return (
    <Card p={0} overflow="hidden">
      {/* Cabeçalho */}
      <Box px="20px" pt="20px" pb="16px">
        <Text fontSize={{ base: "md", md: "lg" }} fontWeight="800" color={textColor}>
          Preferências
        </Text>
        <Text fontSize="sm" color={subColor} mt="2px">
          Configurações do aplicativo
        </Text>
      </Box>

      <Divider borderColor={dividerColor} />

      {/* Linha: Tema escuro/claro */}
      <Flex
        px="20px" py="16px"
        align="center" justify="space-between"
        _hover={{ bg: rowHoverBg }} transition="background .15s"
      >
        <Flex align="center" gap="12px" flex={1} cursor="pointer" onClick={toggleColorMode}>
          <Flex
            w="38px" h="38px" borderRadius="10px"
            bg={isDark ? "purple.100" : "yellow.100"}
            _dark={{ bg: isDark ? "purple.900" : "yellow.900" }}
            align="center" justify="center" flexShrink={0}
          >
            <Icon
              as={isDark ? MdDarkMode : MdLightMode}
              boxSize="18px"
              color={isDark ? "purple.500" : "yellow.500"}
            />
          </Flex>
          <Box>
            <Text fontSize="sm" fontWeight="700" color={textColor}>
              {isDark ? "Modo Escuro" : "Modo Claro"}
            </Text>
            <Text fontSize="xs" color={subColor}>
              {isDark ? "Tema dark ativado" : "Tema light ativado"}
            </Text>
          </Box>
        </Flex>
        <Switch
          isChecked={isDark}
          colorScheme="brand"
          onChange={toggleColorMode}
        />
      </Flex>

      <Divider borderColor={dividerColor} />

      {/* Logout */}
      <Box px="20px" py="16px">
        <Button
          leftIcon={<Icon as={MdLogout} boxSize="18px" />}
          colorScheme="red"
          variant="outline"
          borderRadius="12px"
          h="44px"
          w="100%"
          fontWeight="700"
          onClick={handleLogout}
        >
          Sair da conta
        </Button>
      </Box>
    </Card>
  );
}
